import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";

class ProductSpecialRequest extends Component {
  state = {
    text: this.props.editedProduct?.special_request || "",
  };
  render() {
    let settings = this.props.store.settings;
    let customTexts = settings.custom_texts;

    if (!customTexts) {
      customTexts = {
        special_request_product: "Special Requests",
        special_request_product_ar: "ملاحظات",
      };
    }

    const language = this.props.language;
    let label =
      language === "english"
        ? customTexts.special_request_product
        : customTexts.special_request_product_ar;

    return (
      <div
        className="border mt-4 pt-3"
        style={{
          backgroundColor: "white",
          height: "90px",
          paddingBottom: 80,
        }}
      >
        <p
          className={"text-muted ".concat(
            this.props.language == "english"
              ? "float-left ml-4"
              : "float-right mr-4"
          )}
        >
          {label}
        </p>
        <TextField
          fullWidth
          onChange={(e) => {
            this.props.SetSpecialRequest(e.target.value.trimStart());
          }}
          color="primary"
          style={{ width: "90%" }}
          defaultValue={this.props.specialRequest || ""}
          InputLabelProps={{
            style: {
              right: language == "arabic" && 5,
              left: language == "arabic" && "auto",
            },
            dir: language == "english" ? "ltr" : "rtl",
          }}
          InputProps={{
            dir: language == "english" ? "ltr" : "rtl",
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    store: state.store.store,
    language: state.store.language,
    current_product: state.store.current_product,
  };
};

export default connect(mapStateToProps)(ProductSpecialRequest);
